// extracted by mini-css-extract-plugin
export default {"inputSearchBar":"SearchBar_inputSearchBar__KX2tD"};